<template>
    <button
        type="button"
        class="copy-content-block"
        @click="onClick"
    >
        <slot />

        <svg-icon
            :icon="IconCopy"
            :size="IconSize.sm"
            :color="Color.brandGreen"
        />
    </button>
</template>

<script setup lang="ts">
    import { SvgIcon, Color, IconSize, NotificationBlock } from '@keyvue/one-ui';
    import { useSlots } from 'vue';
    import useClipboard from '@composables/useClipboard';
    import IconCopy from '@keyvue/one-material-icons/icons/content_copy.svg?component';
    import useNotify from '@composables/useNotify';

    const slots = useSlots();
    const clipboard = useClipboard();
    const { notify } = useNotify();

    const onClick = () => {
        const defaultSlot = slots.default?.() || {};
        const content = defaultSlot[0].children;

        if (!content) {
            return;
        }

        clipboard.writeText(content);

        notify({
            component: NotificationBlock,
            props: {
                color: Color.green500,
                title: 'Gekopieerd!',
            },
            duration: 2000,
        });
    };
</script>

<style scoped lang="scss">
:global(.copy-content-block > svg) {
    transition: transform .2s;
}
:global(.copy-content-block:hover > svg) {
    transform: scale(.9);
}

.copy-content-block {
    appearance: none;
    background: none;
    border: none;
    padding: 0;
    margin: 0;
    font: inherit;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: size(xs);
}
</style>
